import * as React from 'react'
import { useMemo } from 'react'
import { ContainerName, useAppUser } from 'components/_hooks'
import { getIsAdmin, getIsOrganizer } from 'store/types/user-types'
import UserListRow from './UserListRow'
import { useDispatch, useSelector } from 'react-redux'
import { ApplicationState } from 'store/types/common'
import { loadTopFriends } from 'store/logic/user-logic'
import { getOrganizerMembersCount, getTopOrganizerMembers, makeGetFriendsCount, makeGetTopFriends } from 'store/selectors/user-selectors'
import { ButtonLink } from '../KlLink/KlLink'
import styles from  './FriendList.module.scss'
import { loadTopMembersPlayers } from 'store/logic/pages/members-page-logic'
import rightMenuStyles from 'components/Layout/partials/RightMenu/RightMenu.module.scss'
import { cn } from 'utils'

const topCount = 12

const FriendListNew = () =>  {

  const dispatch = useDispatch()
  const appUser = useAppUser()
  
  const isOrganizer = getIsOrganizer(appUser?.Role)  
  const isAdmin = getIsAdmin(appUser?.Role)

  const isAdminOrOrganizer = isOrganizer || isAdmin

  const getFriends = useMemo(makeGetTopFriends, [])
  const getFriendsCount = useMemo(makeGetFriendsCount, [])

  const memberList = useSelector((state: ApplicationState) => getTopOrganizerMembers(state, appUser?.Id))
  const friendList = useSelector((state: ApplicationState) => getFriends(state, { userId: appUser?.Id }))
  const friendsCount = useSelector((state: ApplicationState) => getFriendsCount(state, { userId: appUser?.Id }))
  const membersCount = useSelector((state: ApplicationState) => getOrganizerMembersCount(state, appUser?.Id))

  const userList = useMemo(
    () => isAdminOrOrganizer ? memberList : friendList,
    [friendList, isAdminOrOrganizer, memberList]
  )

  const usersCount = useMemo(
    () => isAdminOrOrganizer ? membersCount : friendsCount,
    [isAdminOrOrganizer, membersCount, friendsCount]
  )

  const hasViewAllButton = usersCount > topCount

  React.useEffect(() => { 
    if (isAdminOrOrganizer) {
      dispatch(loadTopMembersPlayers(appUser.Id))
    } else {
      dispatch(loadTopFriends(appUser.Id))
    }
  }, [appUser?.Id, dispatch, isAdminOrOrganizer])

  const allUsersLink =  isAdminOrOrganizer ? '/members/players' : `/player/${appUser.Id}/friends`
  const allUsersTitle = isAdminOrOrganizer ? 'View all members' : 'View all friends'

  return (
    <div className="w-100">
      <div className={cn(rightMenuStyles.rightMenu__header, rightMenuStyles.rightMenu__headerGreen)}>
        { isAdminOrOrganizer ? 'MY MEMBERS LIST' : 'MY FRIENDS LIST' }
      </div>
      <div className={styles.friendListContainer}>
        {userList && userList.length > 0 ? (
          userList.map(frnd => (
            <UserListRow containerName={ContainerName.AvatarsNormal} user={frnd} key={frnd.Id} />
          ))
        ): (
          <div className={styles.emptyFriendList}>
            {`You don't have any ${isAdminOrOrganizer ? 'members' : 'friends'} yet`}
          </div>
        )}
        {hasViewAllButton && (
          <div
            className={styles.friendListRow}
          >
            <ButtonLink to={allUsersLink} color="white" className={styles.viewAllButton}>{allUsersTitle}</ButtonLink>
          </div>
        )}       
      </div>
    </div>
  )
}


export default FriendListNew

